<template>

    <CRow>
        <CCol col="12" lg="8">
            <CCard>
                <CCardHeader>
                    <strong>{{ product.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <CNav variant="tabs">
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}`">
                            Карточка
                        </CNavItem>
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}/edit`">
                            Редактировать
                        </CNavItem>
                        <CNavItem active>
                            Категории
                        </CNavItem>
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}/options`">
                            Опции
                        </CNavItem>
                        <CNavItem :to="`/entities/${$route.params.code}/${$route.params.id}/products/${$route.params.entity_product_id}/variants`">
                            Варианты
                        </CNavItem>
                    </CNav>
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pl-3 pb-3">
                        <CCol sm="4">
                            <CSelect
                                horizontal
                                :options="categoriesOptions"
                                :value.sync="selectedCategory"
                                placeholder="Выберите категорию..."
                            />
                        </CCol>
                        <CCol sm="8">
                            <CButton
                                color="primary"
                                class="ml-3"
                                @click="addCategory">Добавить</CButton>
                        </CCol>
                    </CRow>
                    <CRow class="pl-3">
                        <table class="table">
                            <draggable v-model="categories" tag="tbody">
                                <tr v-for="category in categories" :key="category.title">
                                    <td><CIcon
                                        :height="24"
                                        :content="$options.icons.cilCursorMove"
                                        class="handle" /></td>
                                    <td>{{ category.title }}</td>
                                    <td><CButton @click="removeCategory(category.id)"><CIcon :content="$options.icons.cilTrash" class="handle" /></CButton></td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash } from '@coreui/icons';

    export default {

        name: 'EntityProductCategories',

        components: {
            draggable
        },

        icons: {
            cilCursorMove,
            cilTrash
        },
  
        data () {
            return {
                entity: {},
                product: {},
                categories: [],
                allCategories: [],
                selectedCategory: null
            }
        },
    
        computed: {
            categoriesOptions: function() {
                const categoriesOptions = [];
                this.allCategories.forEach(category => {
                    categoriesOptions.push({
                        value: category.id,
                        label: category.title
                    });
                });
                return categoriesOptions;
            }
        },
  
        mounted() {
            const entityId = parseInt(this.$route.params.id);
            const entity_product_id = parseInt(this.$route.params.entity_product_id);
            const code = this.$route.params.code;
            Vue.axios.get(`/entities/get/${entityId}`)
                .then(resp => {
                    this.entity = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get(`/entities/${entityId}/entity_products/${entity_product_id}`)
                .then(resp => {
                    this.product = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get(`/entities/${entityId}/entity_products/categories/${entity_product_id}`)
                .then(resp => {
                    this.categories = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get(`/entities/${code}/get-categories/${entityId}`)
                .then(resp => {
                    this.setAllCategories(resp.data);
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {

            save() {
                const categoriesToSave = [];
                let index = 0;
                this.categories.forEach(category => {
                    category.position = ++index;
                    categoriesToSave.push(category);
                });
                Vue.axios.post(`/entities/${this.entity.id}/entity_products/categories/${this.product.id}`, { categories: categoriesToSave })
                    .then(() => {
                        this.goBack();
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            setAllCategories(categories) {
                const _allCategories = [];
                categories.forEach(category => {
                    if(this.addCategoryOption(category.id)) {
                        _allCategories.push({
                            id: category.id,
                            title: category.title
                        });
                    }
                });
                this.allCategories = _allCategories;
            },

            addCategoryOption(id) {
                let contains = false;
                for(var i = 0; i < this.categories.length; i++) {
                    if(this.categories[i].id === id) {
                        contains = true;
                    }
                }
                return !contains;
            },

            addCategory() {
                for(var i = 0; i < this.allCategories.length; i++) {
                    if(this.selectedCategory === this.allCategories[i].id) {
                        this.categories.push({
                            id: this.allCategories[i].id,
                            title: this.allCategories[i].title,
                            position: 0
                        });
                        delete this.allCategories[i];
                        break;
                    }
                }
                this.setAllCategories(this.allCategories);
            },

            removeCategory(id) {
                const _categories = []; 
                for(var i = 0; i < this.categories.length; i++) {
                    if(id != this.categories[i].id) {
                        _categories.push(this.categories[i]);
                    }
                }
                this.categories = _categories;
            },

            goBack() {
                this.$router.push({ path: `/entities/${this.entity.entityType.code}/${this.entity.id}/products/${this.product.id}` })
            }
        }
    }

</script>
<style scoped>
.handle {
  cursor: pointer;
}
</style>
